<template>
  <div class="content p-5">
    <div class="about">
      <div class="columns is-centered mt-5">
        <div class="column is-6">
          <h1 class="title is-4">Personal Machine Learning Project</h1>
          <p>
            This is a small project to work on my Vue 3 Composition API skillas
            and to improve my knowledege about Machine Learning, especially with
            Neural Networks and brain.js.
          </p>
          <p>
            Visit my full portfolio at:<br />
            <a href="https://www.frederic-fox.com"
              >https://www.frederic-fox.com</a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
